<template>
  <div
    class="promo-component"
    data-testid="promo-component"
    :class="{'promo-component--error': hasError}"
  >
    <div class="promo-component__input">
      <input
        id="exchange-form-promo"
        v-model="code"
        v-input-width:75="code"
        ref="el"
        type="text"
        aria-label="Enter promo code"
        :placeholder="i18n.t('kano.exchange-form.promo.label').toString()"
      >
    </div>

    <div v-if="hasError" class="promo-component__error">{{ props.error }}</div>

    <div v-else-if="props.capture" class="promo-component__capture">
      {{ props.capture }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useIMask } from 'vue-imask';
import { i18n } from '@kano/i18n';

import vInputWidth from '@kano/directives/InputWidth';

const props = defineProps<{
  value: string;
  capture: string;
  error: string;
}>();

const hasError = computed(() => props.error.length > 0);

const emits = defineEmits<{
  (e: 'input', value: string): void,
}>();

const { el } = useIMask({
  mask: /^[a-zA-Z0-9]*$/,
});

const code = computed({
  get: () => props.value,
  set: (value) => emits('input', value),
});
</script>

<style scoped lang="scss"></style>
